import { render, staticRenderFns } from "./MtoSectorAttachDialog.vue?vue&type=template&id=3849fc76&scoped=true"
import script from "./MtoSectorAttachDialog.vue?vue&type=script&lang=js"
export * from "./MtoSectorAttachDialog.vue?vue&type=script&lang=js"
import style0 from "./MtoSectorAttachDialog.vue?vue&type=style&index=0&id=3849fc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849fc76",
  null
  
)

export default component.exports